export default __webpack_public_path__ + "static/media/scratch.6139cd3d.svg";